import 'src/javascripts/vendor/typeahead.jquery';
import 'src/javascripts/vendor/bloodhound';
import {noResultsTemplate, emptyTemplate, genericDisplayTemplate, topicTemplate, logoTemplate, screenTemplate} from 'src/javascripts/components/typeaheads/TypeaheadTemplates';

// Must define Bloodhound explicitly here
// https://stackoverflow.com/questions/30750916/how-to-reference-typeahead-and-bloodhound-when-loading-npm-typeahead-js
const Bloodhound = require('src/javascripts/vendor/bloodhound');
const accountUrl = $('body').attr('data-account-url');



// Company bloodhounds
export const companiesBloodhound = new Bloodhound({
  datumTokenizer: Bloodhound.tokenizers.obj.whitespace('name'),
  queryTokenizer: Bloodhound.tokenizers.whitespace,
  remote: {
    url: '/research?query=%QUERY',
    wildcard: "%QUERY",
    transform: function(d) { return d.companies; }
  }
});

// Fund bloodhounds
export const fundsBloodhound = new Bloodhound({
  datumTokenizer: Bloodhound.tokenizers.obj.whitespace('name'),
  queryTokenizer: Bloodhound.tokenizers.whitespace,
  remote: {
    url: '/research?query=%QUERY',
    wildcard: "%QUERY",
    transform: function(d) { return d.funds; }
  }
});

// Initiate filter typeaheads
export const filterTypeahead = function(klass, name, url, limit, template) {
  let urlQuery;
  if (url[url.length - 1] !== '?') {
    urlQuery = url + '&query='
  } else {
    urlQuery = url + 'query='    
  }
  let bloodhound = new Bloodhound({
    datumTokenizer: Bloodhound.tokenizers.obj.whitespace('name'),
    queryTokenizer: Bloodhound.tokenizers.whitespace,
    remote: {
      url: urlQuery + '%QUERY',
      wildcard: "%QUERY",
      transform: function(d) { 
        if (typeof d.data !== 'undefined') {
          return d.data; 
        } else {
          return d;
        }
      }
    }});
  bloodhound.initialize();
  $(klass).typeahead({
    hint: true,
    highlight: true,
    minLength: 0,
  }, {
    name: name,
    display: 'name',
    source: bloodhound,
    limit: limit,
    templates: {
      empty: emptyTemplate,
      suggestion(el) {
        if (el.value === null) {
          return noResultsTemplate();
        } else {
          if (template === 'generic') {
            if (typeof el.name !== 'undefined') {
              return genericDisplayTemplate(el.name);
            } else {
              return genericDisplayTemplate(el.value);
            }
          } else if (template === 'topic') {
            return topicTemplate(el.name, el.name_short, el.fa_key, el.value);
          } else if (template === 'logo') {
            return logoTemplate(el.name, el.symbol, el.logo_url, el.value);              
          }
        }
      },
    }
  });
  $(klass).each(function() {
    $(this).data('bloodhound', bloodhound);
  });
  return bloodhound;
} 


// Initiate filter typeaheads with no cache
export const filterTypeaheadNoCache = function(klass, name, url, limit, template) {
  let urlQuery;
  if (url[url.length - 1] !== '?') {
    urlQuery = url + '&query='
  } else {
    urlQuery = url + 'query='    
  }
  let bloodhound = new Bloodhound({
    datumTokenizer: Bloodhound.tokenizers.obj.whitespace('name'),
    queryTokenizer: Bloodhound.tokenizers.whitespace,
    remote: {
      url: urlQuery + '%QUERY',
      wildcard: "%QUERY",
      cache: false,
      transform: function(d) { 
        if (typeof d.data !== 'undefined') {
          return d.data; 
        } else {
          return d;
        }
      }
    }});
  bloodhound.initialize();
  $(klass).typeahead({
    hint: true,
    highlight: true,
    minLength: 0,
  }, {
    name: name,
    display: 'name',
    source: bloodhound,
    limit: limit,
    templates: {
      empty: emptyTemplate,
      suggestion(el) {
        if (el.value === null) {
          return noResultsTemplate();
        } else {
          if (template === 'generic') {
            if (typeof el.name !== 'undefined') {
              return genericDisplayTemplate(el.name);
            } else {
              return genericDisplayTemplate(el.value);
            }
          } else if (template === 'topic') {
            return topicTemplate(el.name, el.name_short, el.fa_key, el.value);
          } else if (template === 'logo') {
            return logoTemplate(el.name, el.symbol, el.logo_url, el.value);              
          }
        }
      },
    }
  });
  $(klass).each(function() {
    $(this).data('bloodhound', bloodhound);
  });
  return bloodhound;
} 

